// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Caption_wrapper__1bnOY","title":"Caption_title__INsy_","arrow":"Caption_arrow__Rj4TB","svg":"Caption_svg__v5H_E"};